module.exports = __webpack_public_path__ + "c8da40d17c3ea9d8c40b00ea5cc107c6.ttf";


//////////////////
// WEBPACK FOOTER
// ./app/fonts/kff-cds.ttf?e1re96
// module id = 786
// module chunks = 0